import { render, staticRenderFns } from "./ModalDeclinedComponent.vue?vue&type=template&id=aea53940&"
import script from "./ModalDeclinedComponent.vue?vue&type=script&lang=js&"
export * from "./ModalDeclinedComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports